<template>
  <div class="related-to-page">
    <ul>
      <li :class="{ active: isActive('/classical/overview') }">
        <router-link to="/classical/overview">All Classical</router-link>
      </li>
      <li :class="{ active: isActive('/classical/roman') }">
        <router-link to="/classical/roman">Roman</router-link>
      </li>
      <li :class="{ active: isActive('/classical/greek') }">
        <router-link to="/classical/greek">Greek</router-link>
      </li>
      <li :class="{ active: isActive('/classical/egyptian') }">
        <router-link to="/classical/egyptian">Egyptian</router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'ClassicalNavigation',
  computed: {
    // Access the current route
    currentRoute() {
      return this.$route.path;
    },
  },
  methods: {
    // Determine if the route matches the current path
    isActive(path) {
      return this.currentRoute === path;
    },
  },
};
</script>